<template>

    <div class="flex items-center justify-between mb-8">

        <Head :title="$t('clients.myApartments')" />

        <page-title :title="$t('clients.myApartments')"></page-title>

        <div class="md:mt-0 md:ml-4 text-right text-sm">
          <!-- Platz für Buttons, falls gebraucht -->
          {{ user.firstname }} {{ user.lastname }}<br>
          <span class="text-gray-400">{{ user.email }}</span>
        </div>
    </div>

    <!-- Apartments -->
    <ul role="list" class="mt-6">
        <li v-for="apartment in apartments" :key="apartment.uuid" class="py-2">
            <client-apartment-card :apartment="apartment"></client-apartment-card>
        </li>
    </ul>


</template>

<script>
import { defineComponent } from "vue";
import PageTitle from "@/Shared/Components/PageTitle";
import MainLayout from "@/Layouts/MainLayout";
import ClientApartmentCard from "@/Pages/Client/Apartment/Components/ClientApartmentCard.vue"
import { Head } from "@inertiajs/inertia-vue3";

export default defineComponent( {
    props: {
      user: Object,
      apartments: Array,
    },
    layout: MainLayout,
    components: {
        Head,
        PageTitle,
        ClientApartmentCard
    },
});
</script>

<style scoped>

</style>
